<template>
  <v-card
    :loading="loading"
    min-height="200px"
    height="100%"
    variant="flat"
    class="metric-tile"
    :class="`bg-${color}-lighten-4`"
    :disabled="noData">
    <v-card-text>
      <v-row class="py-4">
        <v-col class="text-center">
          <v-icon :color="color" size="large">{{ icon }}</v-icon>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <h3 class="font-weigh-bold">
            <slot name="title"/>
          </h3>
        </v-col>
      </v-row>

      <template v-if="!noData">
        <v-row dense>
          <v-col  class="text-center">
            <span class="font-weight-black  text-h3">
              <slot name="metric"/>
            </span>
            <span class="text-h5" v-if="$slots.overMetric">
              / <slot name="overMetric"/>
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-progress-linear
              v-if="progressBarValue !== null"
              :model-value="progressBarValue"
              height="10"
              color="primary"
              rounded
              class="mt-2 mb-1"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="9">
            <slot name="info"/>
          </v-col>
          <v-col cols="3" class="text-right font-weight-bold" v-if="$slots.additionalMetric">
            <slot name="additionalMetric"/>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row v-if="noData" dense>
          <v-col class="text-center">
            <span class="font-weight-black  text-h3">0</span>
          </v-col>
        </v-row>
        <v-row v-if="noData" dense>
          <v-col class="text-center">
            <span class="caption font-weight-bold">
              <slot name="metric-title"/>
            </span>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { PropType} from "vue";

defineProps({
  chipText: {
    type: String as PropType<string>,
  },
  loading: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  color: {
    type: String as PropType<string>,
    default: "green"
  },
  noData: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  progressBarValue: {
    type: Number as PropType<number>,
    default: null
  },
  icon: {
    type: String as PropType<string>,
  },
  options: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => ({
      showAdditionalData: false,
      showDuration: false,
      showNotes: false
    })
  },
  chipType: {
    type: String as PropType<string>,
    validator(value: string) {
      // The value must match one of these strings
      return ["increase", "decrease", "nochange"].includes(value);
    }
  },
});

</script>

<style scoped>
.metric-tile {
  border: 1px solid rgba(0, 0, 0, 0.10);
  background-color: #FFFFFF;
}
</style>
